var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "local_library_black_18dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16752",
    "data-name": "Path 16752",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16753",
    "data-name": "Path 16753",
    d: "M12,11.55A13.153,13.153,0,0,0,3,8V19a13.153,13.153,0,0,1,9,3.55A13.2,13.2,0,0,1,21,19V8A13.153,13.153,0,0,0,12,11.55Zm7,5.58a15.228,15.228,0,0,0-7,2.82,15.2,15.2,0,0,0-7-2.83V10.17A11.179,11.179,0,0,1,10.64,13L12,14.28l1.36-1.27A11.179,11.179,0,0,1,19,10.18Z",
    transform: "translate(0 -2)",
    fill: "#0074b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIconBlue);
export default __webpack_public_path__ + "static/media/bookmark-icon-blue.9b45a4537f8087cce847d1b1b5281e47.svg";
export { ForwardRef as ReactComponent };